module.exports = __webpack_public_path__ + "static/media/sampan.04e71061.png";